import { take, call, select, takeLatest, fork, cancel, put } from 'redux-saga/effects';

import { fetchInfoEvents, fetchInfoEventsCount, getLocations, markAllAsRead, markAsRead, readyToFetchInfoEvents } from './actions';
import { login } from '../auth/actions';
import { logoutButtonClick } from '../../components/Auth/actions';
import { fetchDevicesStats } from '../devices/actions';
import { changeLanguage, markAllEventsClick } from '../../components/Sidebar/actions';
import { apiRequest, geoCodeRequest } from '../../utils/api';
import { bindAsyncAction } from '../../utils/sagas';
import { changeCurrentDevice } from '../../components/Header/actions';
import { filterInfoEvents, changeCurrentInfoEvent } from '../../components/Messages/actions';

const geoCodeWorker = bindAsyncAction(
  getLocations,
  function* load(params) {
    return yield call(geoCodeRequest, params);
  },
);

const infoEventsWorker = bindAsyncAction(
  fetchInfoEvents,
  function* getInfoEvents(params) {
    const { data, cursorInfo, pagingInfo } = yield call(apiRequest, params);
    let geoResponse = [];
    if (!data.length) return { data, cursorInfo, pagingInfo };
    try {
      geoResponse = yield call(geoCodeWorker, {
        body: JSON.stringify({
          requests: data.map((item) => {
            const { event } = item;
            let obj = {
              Latitude: 0,
              Longitude: 0,
            };
            if (event) {
              obj = {
                Latitude: event.lat / 10000000,
                Longitude: event.lon / 10000000,
              };
            }
            return obj;
          }),
        }),
      });
    } catch (e) {
      throw new Error(e);
    }

    const returnData = data.map((j, index) => ({
      ...j,
      ...{
        geoData: geoResponse[index],
      },
    }));

    return {
      data: returnData,
      cursorInfo,
      pagingInfo,
    };
  },
);

const markAsReadWorker = bindAsyncAction(
  markAsRead,
  function* postMarkAsRead(params) {
    return yield call(apiRequest, params);
  },
);

const markAllAsReadWorker = bindAsyncAction(
  markAllAsRead,
  function* postMarkAllAsRead(params) {
    return yield call(apiRequest, params);
  },
);

const eventsCountWorker = bindAsyncAction(
  fetchInfoEventsCount,
  function* fetchEventsCount(params) {
    return yield call(apiRequest, params);
  },
);

function* fetchEvents() {
  const deviceId = yield select(state => state.devices.currentDevice.id);
  const language = yield select(state => state.langs.currentLanguage);
  try {
    yield call(infoEventsWorker, {
      url: '/api/v3/InfoEvents',
      params: {
        Devices: [deviceId],
        Sort: '-created',
        Take: 10,
        Skip: 0,
        Groups: ['Alarm', 'Technical', 'Information'],
        Language: language,
      },
    });
    yield call(eventsCountWorker, {
      url: '/api/v3/InfoEvents/Count',
      params: {
        Devices: [deviceId],
      },
    });
  } catch (e) {
    throw new Error(e);
  }
}

function* filterInfoEventsSaga(action) {
  const params = action.payload;
  const deviceId = yield select(state => state.devices.currentDevice.id);
  const language = yield select(state => state.langs.currentLanguage);

  yield call(infoEventsWorker, {
    url: '/api/v3/InfoEvents',
    params: {
      Devices: [deviceId],
      Sort: '-created',
      Take: 10,
      Skip: params.page * 10 || 0,
      Groups: params.groups || ['Alarm', 'Technical', 'Information'],
      Language: language,
    },
  });
}

function* fetchInfoEventsSaga() {
  yield takeLatest(filterInfoEvents.type, filterInfoEventsSaga);
  while (true) {
    yield take([changeCurrentDevice.type, changeLanguage.type]);

    const deviceId = yield select(state => state.devices.currentDevice.id);
    const language = yield select(state => state.langs.currentLanguage);

    try {
      yield call(eventsCountWorker, {
        url: '/api/v3/InfoEvents/Count',
        params: {
          Devices: [deviceId],
        },
      });

      yield call(infoEventsWorker, {
        url: '/api/v3/InfoEvents',
        params: {
          Devices: [deviceId],
          Sort: '-created',
          Take: 3,
          Skip: 0,
          Groups: ['Alarm', 'Technical', 'Information'],
          Language: language,
        },
      });
    } catch (e) {
      throw new Error(e);
    }
  }
}


function* markInfoEventsSaga() {
  while (true) {
    const { payload } = yield take(changeCurrentInfoEvent.type);

    try {
      yield call(markAsReadWorker, {
        method: 'POST',
        url: '/api/v3/InfoEvents/Mark',
        body: JSON.stringify({
          eventIds: [payload.infoEvent.id],
          status: 'Read',
        }),
      });
    } catch (e) {
      return;
    }
  }
}

function* markAllInfoEventsSaga() {
  while (true) {
    yield take(markAllEventsClick.type);
    const deviceId = yield select(state => state.devices.currentDevice.id);

    yield call(markAllAsReadWorker, {
      method: 'POST',
      url: '/api/InfoEvents/Mark',
      body: JSON.stringify({
        deviceIds: [deviceId],
        status: 'Read',
      }),
    });
  }
}

export default function* infoEventsSaga() {
  while (true) {
    yield take(login.done.type);
    yield take(fetchDevicesStats.done.type);
    const infoEvents = yield fork(markInfoEventsSaga);
    const markAllInfoEvents = yield fork(markAllInfoEventsSaga);
    let fetchInfoEventsFork = null;

    const devices = yield select(state => state.devices.devices);
    if (devices.length) {
      yield call(fetchEvents);
      fetchInfoEventsFork = yield fork(fetchInfoEventsSaga);
      yield put({ type: readyToFetchInfoEvents.type });
    }
    yield take(logoutButtonClick.type);

    yield cancel(infoEvents);
    yield cancel(markAllInfoEvents);
    yield cancel(fetchInfoEventsFork);
  }
}



// WEBPACK FOOTER //
// ./src/sagas/infoEvents/index.js